@if (align === 'start') {
<div class="relative flex flex-col items-start gap-2 px-4 pb-4 pt-3 text-left" data-test="empty-state">
  @if (willySrc) {
    <img [src]="willySrc" alt="" class="absolute right-3 top-3 h-16 w-16 object-contain" data-test="empty-state-willy">
  }
  <ng-content select="[emptyStateKicker]"></ng-content>
  @if (titleKey) {
    <h2 class="pr-20 font-display text-title-l text-vw-ink">{{ titleKey | translate: titleParams }}</h2>
  }
  @if (messageKey) {
    <p class="pr-12 text-body text-vw-body">{{ messageKey | translate: messageParams }}</p>
  }
  <ng-container *ngTemplateOutlet="projected"></ng-container>
  @if (actionKey || secondaryActionKey) {
    <!-- Côte à côte ; « Plus tard » ne passe dessous que si la largeur manque. -->
    <div class="mt-1 flex w-full flex-wrap items-center gap-x-4 gap-y-2">
      @if (actionKey) {
        <button type="button" data-test="empty-state-action" [disabled]="busy" (click)="onAction()"
          class="inline-flex min-h-target items-center gap-2 rounded-pill border-2 border-vw-primary px-4 text-body font-semibold transition disabled:opacity-50"
          [ngClass]="actionLook === 'primary' ? 'bg-vw-primary text-vw-on-color' : 'text-vw-primary active:bg-vw-surface-tint'">
          <ng-container *ngTemplateOutlet="actionIcon"></ng-container>{{ actionKey | translate }}
        </button>
      }
      @if (secondaryActionKey) {
        <!-- Un lien texte à côté du bouton : sa cible de 44 px tient dans sa hauteur, sans marge de plus. -->
        <button type="button" data-test="empty-state-secondary" [disabled]="busy" (click)="onSecondaryAction()"
          class="min-h-target min-w-target text-body font-semibold text-vw-primary disabled:opacity-50">
          {{ secondaryActionKey | translate }}
        </button>
      }
    </div>
  }
</div>
} @else {
<div class="flex flex-col items-center gap-3 text-center" data-test="empty-state"
  [class.px-6]="!compact" [class.py-8]="!compact" [class.py-4]="compact">
  @if (!compact) {
    @if (willySrc) {
      <img [src]="willySrc" alt="" class="h-32 w-32 rounded-full bg-vw-surface-tint object-contain" data-test="empty-state-willy">
    } @else {
      <!-- Icône projetée : pastille vert pâle, trait vert -->
      <span class="flex h-16 w-16 items-center justify-center rounded-full bg-vw-surface-tint text-vw-primary [&>*]:block [&>*]:h-8 [&>*]:w-8" aria-hidden="true">
        <ng-content select="[icon]"></ng-content>
      </span>
    }
  }
  @if (titleKey) {
    <h2 class="text-title-m text-vw-ink">{{ titleKey | translate: titleParams }}</h2>
  }
  @if (messageKey) {
    <p class="text-body text-vw-body">{{ messageKey | translate: messageParams }}</p>
  }
  <ng-container *ngTemplateOutlet="projected"></ng-container>
  @if (actionKey || secondaryActionKey) {
    <div class="mt-1 flex w-full flex-col items-center gap-2">
      @if (actionKey) {
        <!-- 44 px minimum : la cible se touche avec un doigt, parfois ganté -->
        <button type="button" data-test="empty-state-action" [disabled]="busy" (click)="onAction()"
          class="inline-flex min-h-target items-center justify-center gap-2 rounded-pill border-2 border-vw-primary px-6 text-body font-semibold transition disabled:opacity-50"
          [class.w-full]="!!secondaryActionKey"
          [ngClass]="actionLook === 'primary' ? 'bg-vw-primary text-vw-on-color' : 'text-vw-primary active:bg-vw-surface-tint'">
          <ng-container *ngTemplateOutlet="actionIcon"></ng-container>{{ actionKey | translate }}
        </button>
      }
      @if (secondaryActionKey) {
        <!-- Sous un bouton plein, la seconde porte est un bouton contour ; sinon un lien. -->
        <button type="button" data-test="empty-state-secondary" [disabled]="busy" (click)="onSecondaryAction()"
          class="min-h-target font-semibold text-vw-primary disabled:opacity-50"
          [ngClass]="actionLook === 'primary' && actionKey ? 'w-full rounded-pill border-2 border-vw-primary px-6 text-body active:bg-vw-surface-tint' : 'px-4 text-body-s'">
          {{ secondaryActionKey | translate }}
        </button>
      }
    </div>
  }
</div>
}

<!-- Le contenu projeté n'existe qu'une fois : les deux mises en page le posent. -->
<ng-template #projected><ng-content></ng-content></ng-template>
<!-- Le pictogramme du bouton (« + »), projeté avec `emptyStateActionIcon`. -->
<ng-template #actionIcon><ng-content select="[emptyStateActionIcon]"></ng-content></ng-template>
